import { AuthResponse } from '../types/auth'

const API_URL = process.env.REACT_APP_API_URL ?? 'https://localhost:8443'
const API_KEY = process.env.REACT_APP_API_KEY ?? ''

export const authService = {
  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await fetch(`${API_URL}/api/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY },
      body: JSON.stringify({ email, password }),
    })
    if (!response.ok) {
      throw new Error('Invalid credentials')
    }
    return response.json()
  },

  async refresh(refreshToken: string): Promise<AuthResponse> {
    const response = await fetch(`${API_URL}/api/token/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY },
      body: JSON.stringify({ refresh_token: refreshToken }),
    })
    if (!response.ok) {
      throw new Error('Refresh failed')
    }
    return response.json()
  },
}
